import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import BreadCrumbsBar from "../components/breadCrumbsBar";
import BarterCard from "../components/barterCard";
function WhyPage() {
  return (
    <div>
      <Header />
      <BreadCrumbsBar />
      <BarterCard />
      <Footer />
    </div>
  );
}

export default WhyPage;
